import Hall from './hall'
import Field from './field'
import Personal from './personal'

let isAuth = [
    {
        path: '/',
        title: '首页',
        redirect: '/field'
    },
    {
        name: 'index',
        title: '首页',
        component: () => import(/* webpackChunkName: "Index" */ '../views/Index/Index')
    },
    {
        name: 'indexDetails',
        title: '详情',
        component: () =>
            import(/* webpackChunkName: "indexDetails" */ '../views/IndexDetails/Index')
    },
    {
        name: 'publist',
        title: '发布',
        component: () => import(/* webpackChunkName: "publist" */ '../views/Publist/Index')
    },
    {
        name: 'search',
        title: '搜索',
        component: () => import(/* webpackChunkName: "search" */ '../views/Search/index')
    },
    {
        name: 'findFriend',
        title: '发现好友',
        component: () => import(/* webpackChunkName: "findFriend" */ '../views/FindFriend/index')
    },
    {
        name: 'carePeople',
        title: '发现好友',
        component: () => import(/* webpackChunkName: "carePeople" */ '../views/FindFriend/index')
    },
    {
        name: 'collectList',
        title: '收藏列表',
        component: () => import(/* webpackChunkName: "collectList" */ '../views/FindFriend/index')
    },
    {
        name: 'praiseList',
        title: '点赞列表',
        component: () => import(/* webpackChunkName: "praiseList" */ '../views/FindFriend/index')
    },
    {
        name: 'likeList',
        title: '关注列表',
        component: () => import(/* webpackChunkName: "likeList" */ '../views/FindFriend/index')
    },
    {
        name: 'fansList',
        title: '粉丝列表',
        component: () => import(/* webpackChunkName: "fansList" */ '../views/FindFriend/index')
    },
    {
        name: 'blackList',
        title: '黑名单',
        component: () => import(/* webpackChunkName: "blackList" */ '../views/FindFriend/index')
    },
    {
        name: 'setSystem',
        title: '系统设置',
        component: () => import(/* webpackChunkName: "setSystem" */ '../views/setSystem/index')
    },
    {
        name: 'about',
        title: '关于',
        component: () => import(/* webpackChunkName: "about" */ '../views/setSystem/index')
    },
    {
        name: 'reportList',
        title: '举报名单',
        component: () => import(/* webpackChunkName: "reportList" */ '../views/reportList/index')
    },
    {
        name: 'setPage',
        title: '隐私设置',
        component: () => import(/* webpackChunkName: "setPage" */ '../views/SetPage/index')
    },
    {
        name: 'editPage',
        title: '个人资料',
        component: () => import(/* webpackChunkName: "editPage" */ '../views/EditPage/index'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'betaDetail',
        title: 'beta详情',
        component: () => import(/* webpackChunkName: "betaDetail" */ '../views/Beta/detail'),
        meta: {
            regMsg: true
        }
    },
    {
        name: 'rockClimbing',
        title: '寻岩打卡',
        component: () =>
            import(/* webpackChunkName: "rockClimbing" */ '../views/RockClimbing/Index/index')
    },
    ...Hall,
    ...Field,
    ...Personal
]

// 不需要验证
let otherRouter = [
    {
        name: 'login',
        title: '登录',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login/Login')
    },
    {
        name: 'protocol',
        title: '登录',
        component: () => import(/* webpackChunkName: "protocol" */ '../views/Protocol/index')
    },
    {
        name: 'clear',
        title: '清楚缓存',
        component: () => import(/* webpackChunkName: "clear" */ '../views/clear/index')
    },
    {
        name: '*',
        title: '404',
        component: () => import(/* webpackChunkName: "404" */ '../views/NotFound/NotFound')
    }
]

function children(item) {
    const obj = {
        ...item,
        meta: {
            title: item.title
        },
        path: item.name
    }
    item.children && item.children.length > 0 && (obj.children = item.children.map(children))
    return obj
}
// token权限
isAuth = isAuth.map((item) => ({
    ...item,
    meta: {
        title: item.title || '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
    },
    path: item.path ? item.path : `/${item.name}`,
    children: item.children && item.children.length > 0 ? item.children.map(children) : []
}))

// 不需要权限
otherRouter = otherRouter.map((item) => ({
    ...item,
    meta: {
        title: item.title || ''
    },
    path: item.path ? item.path : `/${item.name}`,
    children: item.children && item.children.length > 0 ? item.children.map(children) : []
}))

export const routes = [...isAuth, ...otherRouter]
